import Modal from 'ds/components/modal';
import { useLocale } from 'locale';
import React from 'react';
import { PromotionPlanInfo, PromotionPlanVariant } from 'store/sagas/apiService/types';
import { getPlansForDisplay, planEnhancer, shouldBypassHostedFields } from 'components/private-bulletin-promotion/helpers';
import { PricingCard } from 'components/pricing-card';
import { CardWrapper, Title, Subtitle, TermsBlock, TermsLink } from './styled';
import { TermsPageSectionId, TermsPageSource } from 'screens/TermsPage/types';
import { ISelectPromotionPlanModalProps } from './types';
import { useTermsPageHref } from 'screens/TermsPage/useTermsPageHref';

export const PrivateBulletinSelectPromotionPlanModalBase: React.FC<ISelectPromotionPlanModalProps> = props => {
  const { isOpen, onClose, plans, userId, onPlanSelect, listingUploaded, bulletinId, isHostedFieldsMode, onHostedFieldsPlanSelect } = props;
  const { t } = useLocale();
  const termsOfServiceHref = useTermsPageHref({
    source: TermsPageSource.PromotionPlanSelectionModal,
    sectionId: TermsPageSectionId.PrivateListingPromotionPlanTerms,
  });

  if (!isOpen || !plans) return null;

  const planVariantsAllowedToShow = [
    PromotionPlanVariant.MINI,
    PromotionPlanVariant.ADVANCE,
    PromotionPlanVariant.PREMIUM,
    PromotionPlanVariant.UNTIL_SOLD,
    PromotionPlanVariant.SUBSCRIPTION_MONTHLY,
  ];
  const plansToShow = getPlansForDisplay(plans, planVariantsAllowedToShow);

  const enhancedPlans = planEnhancer(plansToShow, t);

  const handlePlan = (plan: PromotionPlanInfo) => {
    const newListingId = listingUploaded && listingUploaded.data && listingUploaded.data.newListing && listingUploaded.data.newListing.listing && listingUploaded.data.newListing.listing.id;
    const listingId = newListingId || bulletinId || null;
    if (shouldBypassHostedFields(plan, isHostedFieldsMode)) {
      onPlanSelect(plan, userId, listingId);
    }
    else {
      onHostedFieldsPlanSelect(plan, listingId);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={t('privateBulletin.promotion.modal.title')}
    >
      <Title weight="bold">{t('pricingCard.plan.title')}</Title>
      <Subtitle>{t('pricingCard.plan.subtitle')}</Subtitle>
      <CardWrapper>
        {enhancedPlans.map(plan => {
          return (
            <PricingCard
              key={plan.id}
              plan={plan}
              onSelect={() => handlePlan(plan)}
              variant={plan.cardVariant}
            />
          );
        })}
      </CardWrapper>
      <TermsBlock>
        <TermsLink href={termsOfServiceHref} target="_blank" rel="nofollow">
          {t('privateBulletin.promotion.termsOfUse')}
        </TermsLink>
      </TermsBlock>
    </Modal>
  );
};
